import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ButtonToolbar,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field } from 'redux-form';
import Select from '../../../shared/components/form/Select';
import '../scss/CommunicationChannelToReplaceModal.scss';

function CommunicationChannelToReplaceModal(props) {
  const { toggle, modal, title, t, data, selectedDto, updateChannelToReplace } =
    props;

  const [channelToReplace, setChannelToReplace] = useState();

  if (modal) {
    const found = data.findIndex((element) => element.id === selectedDto.id);
    data[found].isDisabled = true;
  }

  const communicationChanelToReplaceChangeHandler = (channel) => {
    setChannelToReplace(channel);
  };

  const onConfirmClickHandler = () => {
    updateChannelToReplace(channelToReplace);
  };

  const onCancelClickHandler = () => {
    const found = data.findIndex((element) => element.id === selectedDto.id);
    data[found].isDisabled = false;
    toggle();
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} backdrop="static" centered>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.communication-channels')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="communicationChanelToReplace"
                type="text"
                component={Select}
                onChange={communicationChanelToReplaceChangeHandler}
                placeholder={t('general.communication-channels')}
                options={data}
                value={channelToReplace}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonToolbar>
            <Button color="primary" onClick={onCancelClickHandler}>
              {t('general.cancel')}
            </Button>{' '}
            <Button color="success" onClick={onConfirmClickHandler}>
              {t('general.confirm')}
            </Button>
          </ButtonToolbar>
        </ModalFooter>
      </Modal>
    </div>
  );
}
CommunicationChannelToReplaceModal.propTypes = {
  title: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  data: PropTypes.shape(PropTypes.shape).isRequired,
  selectedDto: PropTypes.shape(PropTypes.shape).isRequired,
  updateChannelToReplace: PropTypes.func.isRequired,
};

CommunicationChannelToReplaceModal.defaultProps = {
  title: '',
};

export default reduxForm({
  form: 'CommunicationChannelToReplaceModal',
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(CommunicationChannelToReplaceModal));
